export default "__VITE_PUBLIC_ASSET__6aae2f80__"